module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-links_red-8b89bb9d3555e588b43f0b6a24fdaf25.svg";